import React from 'react'
import { login_f, login_r, login_s } from './actiontypes'


const initial = {
    isAuth:false,
    token:null,
    loading:false,
    error:false
}
const reducer = (state=initial,action) => {
    const {payload,type} = action
    switch(type){
     case login_r:
        return {...state,loading:true}
     case login_s:
        return {...state,token:payload,isAuth:true}
     case login_f:
        return {...state,error:true}      

    default:
            return state
    }
  
}

export {reducer}